var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Accounts',[_c('AccountsLogin',{attrs:{"redirect":_vm.redirect,"on-success":null},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h1',{staticClass:"h3 mb-4"},[_vm._v("Please sign in to continue")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }